<div class="dx-fieldset">
  <div class="dx-field">
    <div class="dx-field-label">{{labels.FreeTextSearch}}</div>
    <div class="dx-field-value">
      <dx-text-box #freeSearch [(value)]="freeSearchValue"></dx-text-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">{{labels.Type}}</div>
    <div class="dx-field-value">
      <dx-select-box [dataSource]="documentTypes" valueExpr="DocumentTypeId" displayExpr="Name" [(value)]="documentTypeSearchValue"></dx-select-box>
    </div>
  </div>
  <div class="dx-field">
    <div class="dx-field-label">{{labels.Category}}</div>
    <div class="dx-field-value">
      <dx-select-box [dataSource]="documentCategories" valueExpr="DocumentCategoryId" displayExpr="Description" [(value)]="documentCategorySearchValue"></dx-select-box>
    </div>
  </div>
</div>
